module.exports = __webpack_public_path__ + "img/letter-x.8db7ae2f.svg";